module.exports = __webpack_public_path__ + "f35d6bb0dc7f1b4beb05e94655083849.png";